/* Cart-only transport/saving and old-cart migration. Register before app scripts.
 * All fetch-based cart writes are serialized to prevent native app autosave races.
 * Real checkout still owns shipping method and prices. No payment/order API calls.
 */
(function () {
  'use strict';
  var originalFetch = window.fetch;
  var tail = Promise.resolve();
  window.fetch = function (input, init) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
    var method = (init && init.method || input.method || 'GET').toUpperCase();
    var args = arguments;
    if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/(update|change|add|clear)(\.js)?$/.test(url.pathname)) {
      return originalFetch.apply(window, args);
    }
    var job = tail.then(async function () {
      var controller = new AbortController();
      var upstream = init && init.signal || input.signal;
      var abort = function () {controller.abort();};
      if (upstream) {if (upstream.aborted) abort(); else upstream.addEventListener('abort', abort, {once: true});}
      var timeout = setTimeout(abort, 20000);
      try {return await originalFetch.call(window, input, Object.assign({}, init, {signal: controller.signal}));}
      finally {clearTimeout(timeout); if (upstream) upstream.removeEventListener('abort', abort);}
    });
    tail = job.catch(function () {});
    return job;
  };
  // Debut updates quantities with jQuery/XHR, not fetch. Include those writes
  // in the same queue so a reload/checkout cannot outrun a quantity response.
  var requests = new WeakMap();
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, asynchronous) {
    var result = originalOpen.apply(this, arguments);
    var target = new URL(url, location.href);
    requests.set(this, {cart: asynchronous !== false && method.toUpperCase() === 'POST' && target.origin === location.origin && /\/cart\/(update|change|add|clear)(\.js)?$/.test(target.pathname)});
    return result;
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, request = requests.get(xhr);
    if (!request || !request.cart) return originalSend.apply(xhr, arguments);
    var job = tail.then(function () {
      return new Promise(function (resolve, reject) {
        // jQuery may have timed out/aborted while this request was queued.
        if (xhr.readyState !== 1 || requests.get(xhr) !== request) {resolve(); return;}
        var timeout;
        function done() {clearTimeout(timeout); xhr.removeEventListener('loadend', done); resolve();}
        xhr.addEventListener('loadend', done);
        timeout = setTimeout(function () {xhr.abort(); done();}, 20000);
        try {originalSend.call(xhr, body);}
        catch (error) {clearTimeout(timeout); xhr.removeEventListener('loadend', done); reject(error);}
      });
    });
    tail = job.catch(function () {});
  };
  async function drain() {
    var previous;
    do {previous = tail; await previous;} while (previous !== tail);
  }
  var ready = false, initializing = false, busy = false, failed = false, legacy = [], allowSubmit = false, timer, revision = 0;
  var root, form, status, retry, review, list, apply, updatingDates = false;
  var route;
  var oldKeys = ['gift', 'To', 'From', 'Message', 'Delivery Date'];
  function say(text) {if (status) status.textContent = text;}
  function field(name) {return root.querySelector('[name="attributes[' + name + ']"]');}
  function dateInput() {return field('Delivery Date');}
  function giftInput() {return root.querySelector('.gs__gift-checkbox');}
  function refreshDates() {
    if (updatingDates) return;
    updatingDates = true;
    try {
      var input = dateInput(), fp = input && input._flatpickr;
      var pickup = document.getElementById('ffg-pickup-requested');
      if (!fp || !window.ffgDeliveryDates) throw new Error('Date policy is unavailable');
      window.ffgDeliveryDates.apply(fp, pickup && pickup.checked, window.ffgAdvanceDateRules);
      var sameDay = fp.selectedDates.length > 0 && window.ffgDeliveryDates.isToday(fp.selectedDates[0]);
      var ack = root.querySelector('#ffg-same-day-ack');
      if (!sameDay || ack.dataset.acknowledgedDate !== input.value) ack.checked = false;
      ack.dataset.acknowledgedDate = sameDay ? input.value : '';
      ack.required = sameDay;
      ack.disabled = !sameDay;
      root.querySelector('[data-ffg-same-day-ack-row]').hidden = !sameDay;
      field('Same-day delivery requested').value = sameDay ? 'Yes' : '';
      field('Same-day delivery acknowledged for').value = sameDay && ack.checked ? input.value : '';
    } finally {updatingDates = false;}
  }
  function snapshot() {
    var gift = giftInput().checked;
    return {'Delivery Date': dateInput().value, gift: gift ? 'yes' : '', To: gift ? field('To').value : '', From: gift ? field('From').value : '', Message: gift ? field('Message').value : '',
      'Same-day delivery requested': field('Same-day delivery requested').value,
      'Same-day delivery acknowledged for': field('Same-day delivery acknowledged for').value,
      'Pickup preference requested': '', 'Preferred pickup window': ''};
  }
  function oldItems(cart) {
    return cart.items.filter(function (item) {return oldKeys.some(function (key) {return item.properties && Object.prototype.hasOwnProperty.call(item.properties, key);});});
  }
  async function json(url, body) {
    var response = await fetch(route + url, body ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {cache: 'no-store'});
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  async function persist() {
    var values = snapshot();
    var cart = await json('cart/update.js', {attributes: values});
    if (!cart.attributes || !Object.keys(values).every(function (key) {return (cart.attributes[key] || '') === values[key];})) throw new Error('Save not confirmed');
    return cart;
  }
  function valid() {
    var input = dateInput();
    var fp = input && input._flatpickr;
    if (fp) {
      try {refreshDates();}
      catch (error) {say('Date availability could not be checked. Please reload the cart before checking out.'); return false;}
    }
    if (!fp || !input.value || !fp.selectedDates.length || !fp.isEnabled(fp.selectedDates[0]) || input.value !== fp.formatDate(fp.selectedDates[0], fp.config.dateFormat)) {
      say('Please choose an available delivery / pickup date.');
      if (input) {input.focus(); input.setAttribute('aria-invalid', 'true');}
      return false;
    }
    input.removeAttribute('aria-invalid');
    var ack = root.querySelector('#ffg-same-day-ack');
    if (ack.required && !ack.checked) {
      say('Please acknowledge the $69.99 same-day delivery fee and staff confirmation requirement. Same-day pickup is not available.');
      ack.focus(); return false;
    }
    if (snapshot().Message.length > 80) {say('Please keep the card message within 80 characters.'); field('Message').focus(); return false;}
    return true;
  }
  function lock(value) {busy = value; form.inert = value; root.setAttribute('aria-busy', String(value));}
  async function settle() {
    clearTimeout(timer);
    // Let Giftship's own 500ms debounce finish while the form is locked.
    await new Promise(function (resolve) {setTimeout(resolve, 700);});
    await drain();
    return persist();
  }
  async function saveOnly() {
    if (!ready || busy) return;
    failed = false;
    var savingRevision = revision;
    try {refreshDates(); await persist(); await drain(); if (savingRevision === revision) say('Order details saved.');}
    catch (error) {failed = true; say('Order details could not be saved. Please retry before checking out.');}
    retry.hidden = !failed;
  }
  function edited() {
    if (!ready || busy || updatingDates) return;
    try {refreshDates();}
    catch (error) {say('Date availability could not be checked. Please reload the cart.'); return;}
    revision += 1;
    say('Saving order details…');
    clearTimeout(timer);
    timer = setTimeout(saveOnly, 250);
  }
  async function checkout(submitter) {
    if (busy) return;
    if (!ready) {say(window.ffgOrderDetailsError || 'Order details are still loading. Please wait or reload the page.'); return;}
    if (!valid()) return;
    if (legacy.length) {say('Please review and apply your existing item details before checking out.'); review.scrollIntoView({block: 'center'}); return;}
    var button = submitter && submitter.form === form ? submitter : form.querySelector('[name="checkout"]');
    if (!button || button.disabled || !button.getClientRects().length || getComputedStyle(button).visibility === 'hidden') {
      say('Please complete the delivery-area check in the cart before checking out.'); return;
    }
    lock(true); say('Saving order details before checkout…');
    try {
      var confirmed = await settle();
      // A cutoff or midnight can pass during the final save. Recheck before
      // handing control back to the normal checkout/postal-validation path.
      if (!valid()) {lock(false); return;}
      var renderedKeys = Array.from(form.querySelectorAll('[data-cart-item]')).map(function (row) {return row.dataset.cartItemKey;});
      var renderedQuantities = Array.from(form.querySelectorAll('[data-cart-item]')).map(function (row) {return Number(row.dataset.cartItemQuantity);});
      if (oldItems(confirmed).length || JSON.stringify(confirmed.items.map(function (item) {return item.key;})) !== JSON.stringify(renderedKeys) || JSON.stringify(confirmed.items.map(function (item) {return item.quantity;})) !== JSON.stringify(renderedQuantities)) {
        say('Your cart changed. Reloading it for review…'); location.reload(); return;
      }
      failed = false; retry.hidden = true;
      lock(false);
      // Resume the normal form path, not a direct /checkout redirect. Other cart
      // guards (including postal validation and pickup preference) still apply.
      allowSubmit = true;
      try {if (button.isConnected && !button.disabled && button.getClientRects().length) button.click();}
      finally {allowSubmit = false;}
    } catch (error) {
      failed = true; lock(false); retry.hidden = false;
      say('Order details could not be saved. Please retry before checking out.');
    }
  }
  async function migrate() {
    if (busy || !ready || !valid()) return;
    lock(true); say('Moving your confirmed details to the order…');
    try {
      var cart = await settle();
      var item;
      while ((item = oldItems(cart)[0])) {
        var properties = Object.assign({}, item.properties);
        var archive = {};
        oldKeys.forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(properties, key)) {archive[key] = properties[key]; delete properties[key];}
        });
        // Preserve original data privately; do not keep active conflicting gift
        // fields on each item. Non-gift properties and quantity are unchanged.
        properties._ffg_previous_gift_details = JSON.stringify(archive);
        var previousCount = oldItems(cart).length;
        var previousQuantity = cart.item_count;
        cart = await json('cart/change.js', {id: item.key, quantity: item.quantity, properties: properties});
        if (oldItems(cart).length >= previousCount || cart.item_count !== previousQuantity) throw new Error('Migration not confirmed');
      }
      try {sessionStorage.setItem('ffg-order-migrated', '1');} catch (storageError) { /* Optional success notice only. */ }
      location.reload(); // line keys can change; let the theme render fresh keys.
    } catch (error) {
      lock(false); failed = true; retry.hidden = false;
      say('The migration did not finish. Your original details are preserved. Reload the cart and review before trying again.');
    }
  }
  async function initialize() {
    if (ready || initializing || !root || !dateInput() || !dateInput()._flatpickr || !field('Message')) return;
    initializing = true;
    try {
      if (window.ffgCartGuardInstalled !== true) throw new Error('Cart readiness gate is unavailable');
      await drain();
      var cart = await json('cart.js');
      refreshDates();
      // A native initialization can discard today's saved request before our
      // local policy takes over. Restore only if the policy now permits it.
      if (!dateInput().value && cart.attributes && cart.attributes['Delivery Date']) {
        dateInput()._flatpickr.setDate(cart.attributes['Delivery Date'], false);
      }
      legacy = oldItems(cart);
      if (legacy.length) {
        review.hidden = false;
        legacy.forEach(function (item) {
          var li = document.createElement('li');
          var details = oldKeys.filter(function (key) {return item.properties[key];}).map(function (key) {return key + ': ' + item.properties[key];}).join(' · ');
          li.textContent = item.product_title + ' — ' + details;
          list.appendChild(li);
        });
        // Prefill only unanimous non-empty values, and never overwrite an
        // existing order-level value. Conflicting values require a human choice.
        var dates = Array.from(new Set(legacy.map(function (i) {return i.properties['Delivery Date'] || '';}).filter(Boolean)));
        if (!dateInput().value && dates.length === 1) dateInput()._flatpickr.setDate(dates[0], false);
        var cards = Array.from(new Set(legacy.map(function (i) {return JSON.stringify({To: i.properties.To || '', From: i.properties.From || '', Message: i.properties.Message || ''});})));
        if (cards.length === 1 && !field('To').value && !field('From').value && !field('Message').value) {
          var card = JSON.parse(cards[0]);
          if (card.To || card.From || card.Message) {
            giftInput().checked = true;
            giftInput().dispatchEvent(new Event('change', {bubbles: true}));
            ['To', 'From', 'Message'].forEach(function (key) {field(key).value = card[key];});
          }
        }
      }
      refreshDates();
      ready = true;
      root.inert = false;
      root.dataset.ready = 'true';
      document.documentElement.setAttribute('data-ffg-cart-ready', 'true');
      say(legacy.length ? 'Review the existing item details before continuing.' : '');
      try {
        if (sessionStorage.getItem('ffg-order-migrated')) {sessionStorage.removeItem('ffg-order-migrated'); say('Existing item details have been moved to this order.');}
      } catch (storageError) { /* Cart functionality does not require web storage. */ }
      if (legacy.length || ['Delivery Date', 'Same-day delivery requested', 'Same-day delivery acknowledged for', 'Pickup preference requested', 'Preferred pickup window'].some(function (key) {
        return (cart.attributes && cart.attributes[key] || '') !== snapshot()[key];
      })) edited();
    } catch (error) {say('Order details could not be loaded. Please reload the cart.');}
    finally {initializing = false;}
  }
  function start() {
    root = document.querySelector('[data-ffg-order-details]');
    if (!root) return;
    root.inert = true;
    form = root.closest('form'); status = root.querySelector('[data-ffg-order-status]');
    retry = root.querySelector('[data-ffg-order-retry]'); review = root.querySelector('[data-ffg-legacy-review]');
    list = root.querySelector('[data-ffg-legacy-list]'); apply = root.querySelector('[data-ffg-legacy-apply]');
    route = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    root.addEventListener('input', edited);
    root.addEventListener('change', function (event) {
      // Giftship's optional toggle can leave hidden text fields enabled. Clear
      // them before app handlers serialize the form, including a normal POST.
      if (event.target === giftInput() && !event.target.checked) {
        ['To', 'From', 'Message'].forEach(function (key) {field(key).value = '';});
      }
      edited();
    }, true);
    retry.addEventListener('click', saveOnly); apply.addEventListener('click', migrate);
    document.addEventListener('change', function (event) {
      if (event.target.id === 'ffg-pickup-requested') edited();
    });
    function clockChanged() {
      if (!ready || busy || document.hidden) return;
      var before = JSON.stringify(snapshot());
      try {refreshDates(); if (JSON.stringify(snapshot()) !== before) edited();}
      catch (error) {say('Date availability could not be checked. Please reload the cart.');}
    }
    window.addEventListener('focus', clockChanged);
    document.addEventListener('visibilitychange', clockChanged);
    setInterval(clockChanged, 60000);
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (ready || attempts > 150) {
        clearInterval(poll);
        if (!ready) say(window.ffgOrderDetailsError || 'Order details did not load. Please reload the cart or contact the shop.');
      } else initialize();
    }, 200);
  }
  // Capture handlers are installed before the apps, including their click guards.
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!target || !root || allowSubmit) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(target);
  }, true);
  document.addEventListener('submit', function (event) {
    if (!root || event.target !== form || allowSubmit) return;
    // Preserve update-cart controls; checkout and Enter from an order field must
    // both pass required-date validation and final save confirmation.
    if (event.submitter && event.submitter.name === 'update') return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout(event.submitter);
  }, true);
  document.addEventListener('giftship.datepicker.updated', edited);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
